import actionTypes from 'constants/snapSellWizardConstants';

export function goToNextSnapSellStep() {
  return (dispatch) => {
    dispatch({ type: actionTypes.SNAPSELL_GO_TO_NEXT_STEP });
  };
}

export function goToSnapSellStep(step) {
  return (dispatch) => {
    if (step >= 1) {
      dispatch({ type: actionTypes.SNAPSELL_GO_TO_STEP, payload: step });
    } else {
      dispatch({ type: actionTypes.SNAPSELL_STEP_CHANGE_REJECTED });
    }
  };
}

export function goToPreviousSnapSellStep() {
  return (dispatch, getState) => {
    if (getState().snapSellWizard.get('currentStep') > 1) {
      dispatch({ type: actionTypes.SNAPSELL_GO_TO_PREVIOUS_STEP });
    } else {
      dispatch({ type: actionTypes.SNAPSELL_STEP_CHANGE_REJECTED });
    }
  };
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/snapSellWizardActions.js